import { Link, useLocation, useNavigate } from "react-router-dom";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useState } from "react";
import { useSession } from "./SessionContext";
import { API_URL } from "../config";
//import { uploads } from "../config";

const Header = () => {
  const { session, setSession } = useSession();
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const toggleDiv = () => setIsVisible(!isVisible);

  const location = useLocation();
  const navigate = useNavigate();

  const hideMenuRoutes = [
    "/dashboard",
    "/personal-details",
    "/business-details",
    "/contact-details",
    "/photo-gallery",
    "/change-password",
  ];

  const showMenu = !hideMenuRoutes.includes(location.pathname);

  const handleLogout = async () => {
    try {
      const res = await fetch(
        `${API_URL}/api-logout.php`,
        {
          method: "POST",
          credentials: "include",
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        setSession(null); // ✅ global update
        navigate("/login?action=logout");
      } else {
        alert(data.message || "Logout failed");
      }
    } catch (err) {
      console.error(err);
    }
  };

  //const toggleDiv = () => setIsVisible(!isVisible);

  return (
    <div className="header">
      <div className="container">
        <div className="logo d-flex">
          <img src="/images/logo.png" className="fullimg" alt="Bagaha Bazar" />
        </div>
        {showMenu && (
          <div className="menu-box d-flex">
            <div className={`menu ${isOpen ? "open" : ""}`}>
              <Link to="/">Home</Link>
              <Link to="/services">Services</Link>
              <Link to="/listing">Listing</Link>
              <Link to="/details">Details</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/about">About Us</Link>
              <Link to="/contact">Contact Us</Link>
            </div>

            <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
              ☰
            </div>
          </div>
        )}


        {session ? (

          <div className="user-box d-flex dbuser">
            <div className="user-btn d-flex" onClick={toggleDiv}>
              <div className="user-icon d-flex align-items-center"><AccountCircleOutlinedIcon /></div>
              <div className="user d-flex align-items-center">{session.userfname}</div>
            </div>
            
            <div className={isVisible ? "user-menu" : "user-menu hide"} onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
              <Link to="/dashboard">Dashboard</Link>
              <button onClick={handleLogout}>Logout</button>
            </div>

          </div>
        ) : (
          <div className="user-box d-flex reglogin">
            <Link to="/login" className="login-btn d-flex align-items-center"><AccountCircleOutlinedIcon /> Login</Link>
            <Link to="/register" className="reg-btn d-flex align-items-center">Register</Link>
          </div>
        )}

        <div className="clr"></div>
      </div>
    </div>
  );
};

export default Header;
